import { render, staticRenderFns } from "./import-products.modal.vue?vue&type=template&id=1f1e9b5d&scoped=true&"
import script from "./import-products.modal.vue?vue&type=script&lang=js&"
export * from "./import-products.modal.vue?vue&type=script&lang=js&"
import style0 from "./import-products.modal.vue?vue&type=style&index=0&id=1f1e9b5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e9b5d",
  null
  
)

export default component.exports